export function increaseTemp(delta, target_temperature, min_temperature, max_temperature, exist) {
    const delta_for_observe_off_mode = delta > 0 ? 0 : 1;
    const default_temperature = Math.round(target_temperature ?? min_temperature + delta_for_observe_off_mode);
    const value = exist ?? default_temperature;
    // https://git.microline.ru/zont/server/-/issues/1722
    const new_value = Math.round((value + delta) / delta) * delta;
    if (new_value <= max_temperature && new_value >= min_temperature) {
        return new_value;
    }
    if (new_value > max_temperature) {
        return max_temperature;
    }
    if (new_value < min_temperature) {
        return min_temperature;
    }
    return exist;
}
